export default __webpack_public_path__ + "static/media/Quezon-City.0b7a00d9.png";